<template>
  <div
    v-if="entriesCount"
    class="transaction-info-entries"
    :class="entitiesClasses"
  >
    <Entry
      v-for="index in entriesCount"
      ref="entryRef"
      :key="index"
      :instance
      :index
      @edit="handleEdit"
    >
      <template v-if="$slots.label" #label>
        <slot name="label" />
      </template>
      <template v-if="$slots.account" #account>
        <slot name="account" />
      </template>
      <template v-if="$slots.amount" #amount>
        <slot name="amount" />
      </template>
      <template v-if="$slots.asset" #asset>
        <slot name="asset" />
      </template>
    </Entry>
  </div>
</template>

<script setup lang="ts">
import { computed, useTemplateRef } from 'vue'

import { TransactionClass } from '@types'

import Entry from './components/Entry.vue'

type Props = {
  instance?: TransactionClass
}

type Emits = {
  edit: [string]
}

const props = defineProps<Props>()
const emit = defineEmits<Emits>()

defineExpose({
  reset: (field?: string) => {
    entryRef.value?.forEach(entry => {
      entry?.reset(field)
    })
  },
})

const entryRef = useTemplateRef('entryRef')

const entriesCount = computed(() => props.instance?.entriesLength || 2)

const entitiesClasses = computed(() => ({
  [`transaction-info-entries--cols-${entriesCount.value}`]: entriesCount.value,
}))

const handleEdit = (field: string) => {
  emit('edit', field)
}
</script>

<style>
.transaction-info-entries {
  @apply grid grid-cols-1 gap-2;
  @apply -mx-2 -mb-2;

  &--cols-2 {
    @apply grid-cols-2;
  }

  &--cols-3 {
    @apply grid-cols-3;
  }

  &--cols-4 {
    @apply grid-cols-4;

    .ui-transaction-info--md & {
      @apply grid-cols-2;
    }
  }

  .ui-transaction-info--sm & {
    @apply !grid-cols-1;
  }
}
</style>
